import {WorkingSizeContext, WorkingSizeDispatch} from "../context/WorkingSizeContext";
import {useContext, useState, useEffect} from "react";

const minWidth = 20;
const maxWidth = 70;
const minHeight = 20;
const maxHeight = 70;
const minScale = 0.3;
const maxScale = 1;

const WorkingSizeSelector = () => {
    const workingSizeContext = useContext(WorkingSizeContext);
    const dispatch = useContext(WorkingSizeDispatch);

    // Lokalne stany dla inputów
    const [width, setWidth] = useState(workingSizeContext.widthCm);
    const [height, setHeight] = useState(workingSizeContext.heightCm);
    const [scale, setScale] = useState(workingSizeContext.scale);

    // Stan błędu
    const [error, setError] = useState('');

    // Synchronizuj lokalny stan z kontekstem po zmianie kontekstu
    useEffect(() => {
        setWidth(workingSizeContext.widthCm);
        setHeight(workingSizeContext.heightCm);
        setScale(workingSizeContext.scale);
    }, [workingSizeContext.widthCm, workingSizeContext.heightCm, workingSizeContext.scale]);

    // Walidacja po każdej zmianie inputów
    useEffect(() => {
        let err = '';
        if (width < minWidth || width > maxWidth) {
            err = `Szerokość powinna być w zakresie ${minWidth}-${maxWidth} cm`;
        } else if (height < minHeight || height > maxHeight) {
            err = `Wysokość powinna być w zakresie ${minHeight}-${maxHeight} cm`;
        } else if (scale < minScale || scale > maxScale) {
            err = `Skala powinna być w zakresie ${minScale}-${maxScale}`;
        }
        setError(err);
    }, [width, height, scale]);

    const handleWidthChange = (e) => {
        setWidth(Number(e.target.value));
    };

    const handleHeightChange = (e) => {
        setHeight(Number(e.target.value));
    };

    const handleScaleChange = (e) => {
        setScale(Number(e.target.value));
    };

    const handleApply = (e) => {
        e.preventDefault();
        if (!error) {
            dispatch({
                type: 'setWorkingSizeCm',
                payload: {
                    widthCm: width,
                    heightCm: height
                }
            });
            dispatch({
                type: 'setScale',
                payload: { scale }
            });
        }
    };

    return (
        <div className="row" style={{ flexWrap : 'wrap' , alignItems: 'center', justifyContent: 'center' }}>
            <div className="h3" style={{textAlign: "center"}}>Wybierz rozmiary obszaru roboczego:</div>
            <label className="col-3">Szerokość (cm):
                <input
                    className="mt-2 w-100"
                    type="number"
                    id="workingSizeWidth"
                    min={minWidth}
                    max={maxWidth}
                    placeholder="Szerokość"
                    aria-label="Wybierz szerokość rozmiaru roboczego"
                    value={width}
                    onChange={handleWidthChange}
                />
            </label>
            <label className="col-3">Wysokość (cm):
                <input
                    className="mt-2 w-100"
                    type="number"
                    min={minHeight}
                    max={maxHeight}
                    id="workingSizeHeight"
                    placeholder="Wysokość"
                    aria-label="Wybierz wysokość rozmiaru roboczego"
                    value={height}
                    onChange={handleHeightChange}
                />
            </label>
            <label className="col-2">Skala:
                <input
                    className="mt-2 w-100"
                    type="number"
                    min={minScale}
                    max={maxScale}
                    step="0.1"
                    id="workingSizeScale"
                    placeholder="Skala"
                    aria-label="Wybierz skalę rozmiaru roboczego"
                    value={scale}
                    onChange={handleScaleChange}
                />
            </label>
            {/* Komunikat błędu */}
            {error && (
                <span
                    style={{
                        fontSize: '1.2rem',
                        color: 'red',
                        fontWeight: 'bold',
                        textAlign: 'center',
                        width: '100%',
                        margin: '10px 0'
                    }}
                >
                    {error}
                </span>
            )}
            <div className="col-12" style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                <button
                    className="btn btn--secondary"
                    onClick={handleApply}
                    disabled={!!error}
                >
                    Zatwierdź zmiany
                </button>
            </div>
        </div>
    )
}

export default WorkingSizeSelector;